import http from "../axios/http-common";

class InterfaceRiwayat {
  getRiwayatByRm(rm,expand) {
    return http.getDataParam(`/pasien/${rm}/register`, {
      params: {
        expand: expand
      }
    });
  }
}
export default new InterfaceRiwayat();
